import {Permissions} from "@/js/Permissions";

const XCERoutes = [
  {
    path: "/xce/overnight-research",
    name: "xce_overnight_research_index",
    component: () => import("@/views/xce/overnight_research/IndexView.vue"),
    meta: {permissions: [Permissions.KEPLER_OVERNIGHT_RESEARCH, Permissions.DISPUTES_OVERNIGHT_RESEARCH]},
  },
  {
    path: "/xce/overnight-research/:id/logs",
    name: "xce_overnight_research_logs",
    component: () => import("@/views/xce/overnight_research/LogsIndexView.vue"),
    meta: {permissions: [Permissions.KEPLER_OVERNIGHT_RESEARCH, Permissions.DISPUTES_OVERNIGHT_RESEARCH]},
  },
  {
    path: "/xce/overnight-research/import",
    name: "xce_overnight_research_importer",
    component: () => import("@/views/xce/overnight_research/ImportView.vue"),
    meta: {permissions: [Permissions.KEPLER_OVERNIGHT_RESEARCH, Permissions.DISPUTES_OVERNIGHT_RESEARCH]},
  },
]

export default XCERoutes;
